import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { items } = useWishlist();
  const { user } = useAuth();
  const { t } = useLang();

  if (user === false) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        <Heart size={48} className="mx-auto text-rose-400" />
        <h1 className="mt-6 font-display font-black text-3xl">{t("wishlist.signInPrompt")}</h1>
        <Link to="/login" className="mt-6 inline-flex h-11 px-6 items-center bg-ink text-white rounded-full text-xs font-mono uppercase tracking-[0.2em] hover:bg-electric">
          {t("nav.signin")}
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="wishlist-page" className="max-w-[1400px] mx-auto px-6 md:px-12 py-12">
      <div className="text-xs font-mono uppercase tracking-[0.3em] text-slate-500">{t("wishlist.eyebrow")}</div>
      <h1 className="mt-2 font-display font-extrabold text-4xl sm:text-5xl tracking-tight">{t("wishlist.title")}</h1>
      <div className="mt-2 text-sm font-mono text-slate-500">
        {items.length} {items.length === 1 ? t("cart.itemCountSingular") : t("cart.itemCount")}
      </div>

      {items.length === 0 ? (
        <div className="mt-16 text-center py-20 bg-secondary rounded-2xl">
          <Heart size={40} className="mx-auto text-rose-400 mb-4" />
          <div className="font-display font-bold text-2xl">{t("wishlist.empty")}</div>
          <p className="mt-2 text-slate-600">{t("wishlist.emptyHint")}</p>
          <Link to="/shop" className="mt-6 inline-flex h-11 px-6 items-center bg-ink text-white rounded-full text-xs font-mono uppercase tracking-[0.2em] hover:bg-electric">
            {t("common.browseUnits")}
          </Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
